"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const ModuleWrapper_vue_1 = tslib_1.__importDefault(require("../../assets/uis/containers/ModuleWrapper.vue"));
const SectionTitle_vue_1 = tslib_1.__importDefault(require("../../assets/uis/containers/SectionTitle.vue"));
const StockCard_vue_1 = tslib_1.__importDefault(require("../../assets/uis/containers/StockCard.vue"));
const IntroText_vue_1 = tslib_1.__importDefault(require("../../assets/uis/IntroText.vue"));
const MoreButton_vue_1 = tslib_1.__importDefault(require("../../assets/uis/MoreButton.vue"));
const TagList_vue_1 = tslib_1.__importDefault(require("../../assets/uis/TagList.vue"));
const enum_1 = require("../../common/enum");
const scheme_1 = require("../../common/scheme");
const useI18n_1 = require("../../common/useI18n");
const fegoProps_1 = require("../../models/fegoProps");
const AnalystQuote_vue_1 = tslib_1.__importDefault(require("../_cards/AnalystQuote.vue"));
const AnalystStats_vue_1 = tslib_1.__importDefault(require("../_cards/AnalystStats.vue"));
const AnalystStockItem_vue_1 = tslib_1.__importDefault(require("../_cards/AnalystStockItem.vue"));
const __sfc_main = {};
__sfc_main.props = {
    introTitle: {
        type: String,
        default: ''
    },
    analystData: {
        type: Object,
        default: undefined
    },
    languageId: {
        type: Number,
        default: useI18n_1.LanguageId.EN
    },
    upDownColor: {
        type: Number,
        default: enum_1.UP_DOWN_COLOR.GREEN_UP
    },
    selfSelectedMap: {
        type: Object,
        default: () => ({})
    },
    wchNumMap: {
        type: Object,
        default: () => ({})
    },
    showWchNum: {
        type: Boolean,
        default: true
    },
    pageType: {
        type: String,
        default: fegoProps_1.SignalSelectedPageType.PRIMARY
    },
    viewMoreUrl: {
        type: String,
        default: undefined
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const props = __props;
    const emit = __ctx.emit;
    // 多语言
    const languageId = (0, vue_demi_1.computed)(() => props.languageId);
    const $t = (0, useI18n_1.useI18n)(props.languageId);
    // 涨跌色
    const upDownColor = (0, vue_demi_1.computed)(() => props.upDownColor);
    // 处理自选点击
    const handleToggleSelfSelected = (stockId, $event) => {
        emit('toggle-self-selected', stockId, $event);
    };
    const tags = (0, vue_demi_1.ref)([]);
    const introText = (0, vue_demi_1.ref)('');
    const analystList = (0, vue_demi_1.ref)([]);
    const expandedCards = (0, vue_demi_1.ref)([]);
    const updateTime = (0, vue_demi_1.ref)(undefined);
    // 监听 analystData 变化，更新内部状态
    (0, vue_demi_1.watch)(() => props.analystData, newData => {
        if (newData) {
            tags.value = newData.tags;
            introText.value = newData.introText;
            analystList.value = newData.analystList;
            updateTime.value = newData.updateTime;
            // 初始化展开状态数组，默认展开第一个卡片
            expandedCards.value = newData.analystList.map((_, index) => index === 0);
        }
    }, {
        immediate: true
    });
    const toggleCard = (index) => {
        expandedCards.value[index] = !expandedCards.value[index];
    };
    const handleMore = () => {
        if (props.viewMoreUrl) {
            window.open(props.viewMoreUrl, '_blank');
        }
    };
    const { jumpToStockAnalystDetail, jumpToAnalystDetail } = (0, scheme_1.useJump)(props);
    return {
        SignalSelectedPageType: fegoProps_1.SignalSelectedPageType,
        languageId,
        $t,
        upDownColor,
        handleToggleSelfSelected,
        tags,
        introText,
        analystList,
        updateTime,
        handleMore,
        jumpToStockAnalystDetail,
        jumpToAnalystDetail
    };
};
__sfc_main.components = Object.assign({
    ModuleWrapper: ModuleWrapper_vue_1.default,
    TagList: TagList_vue_1.default,
    IntroText: IntroText_vue_1.default,
    StockCard: StockCard_vue_1.default,
    AnalystQuote: AnalystQuote_vue_1.default,
    AnalystStats: AnalystStats_vue_1.default,
    SectionTitle: SectionTitle_vue_1.default,
    AnalystStockItem: AnalystStockItem_vue_1.default,
    MoreButton: MoreButton_vue_1.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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